// extracted by mini-css-extract-plugin
module.exports = {"JobBoardContainer":"JobBoardContainer_JobBoardContainer__3sG1r","FiltersLegendWrapper":"JobBoardContainer_FiltersLegendWrapper__31geY"};